<template>
<div>
    <Breadcrumbs main="Admin" submain="Content" title="Advocacy" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add New</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="advocacy_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(title)="row">
                                        <div v-if="row.item.title" style="max-width: 250px;">
                                            <div>{{ row.item.title }}</div>
                                        </div>
                                    </template>

                                    <template #cell(category)="row">
                                        <div v-if="row.item.category" style="max-width: 200px;">
                                            <div>{{ row.item.category?.title }}</div>
                                        </div>
                                    </template>

                                    <template #cell(image)="row">
                                        <div v-if="row.item.image">
                                            <img style="width: 120px; border-radius: 4px;" :src="host + row.item.image" alt="">
                                        </div>
                                    </template>

                                    <template #cell(description)="row">
                                        <div v-if="row.item.description && row.item.description.length > 200" style="max-width: 450px;">
                                            <div v-html="row.item.description.slice(0, 200) + '...'"></div>
                                        </div>
                                        <div v-else style="max-width: 450px;">
                                            <div v-html="row.item.description"></div>
                                        </div>
                                    </template>

                                    <template #cell(featured)="row">
                                        <div>
                                            <span v-if="row.item.featured === true" style="cursor: pointer;">
                                                <b-badge pill variant="success" v-b-tooltip.hover title="Toggle featured" @click="toggleFeatured(row.item.slug)">Yes</b-badge>
                                            </span>
                                            <span v-if="row.item.featured === false" style="cursor: pointer;">
                                                <b-badge pill variant="danger" v-b-tooltip.hover title="Toggle featured" @click="toggleFeatured(row.item.slug)">No</b-badge>
                                            </span>
                                        </div>
                                    </template>

                                    <template #cell(custom)="row">
                                        <div>
                                            <span v-if="row.item.custom === true" style="display: flex; flex-direction: column; align-items: start;">
                                                <b-badge pill variant="success" v-b-tooltip.hover title="Toggle custom" @click="toggleCustom(row.item.slug)">Yes</b-badge>
                                                <router-link :to="`/custom-ui/advocacy/${row.item.slug}`">
                                                    <b-badge pill variant="primary">Details</b-badge>
                                                </router-link>
                                            </span>
                                            <span v-else>
                                                <router-link :to="`/custom-ui/advocacy/${row.item.slug}`"> 
                                                    <b-badge pill variant="danger" v-b-tooltip.hover title="Toggle custom">No</b-badge>
                                                </router-link>
                                            </span>
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteAdvocacy(data.item.id)" title="Delete"></feather>
                                            </div>

                                            <div @click="editAdvocacy(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Advocacy Create Modal --> 
    <b-modal id="modal-prevent-closing" ref="modal" title="Add Advocacy" size="xl" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" v-model="advocacy.title" placeholder="Enter advocacy title" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Youtube Video Link</label>
                        <input class="form-control" type="text" v-model="advocacy.link" placeholder="Enter youtube video link" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Category</label>
                        <select class="form-control digits" v-model="advocacy.category">
                            <option v-for="(type, index) in categories" :key="index" :value="type.id">{{ type.title }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Description</label>
                        <ckeditor :editor="editor" v-model="advocacy.description" placeholder="Enter advocacy description"></ckeditor>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group px-3">
                    <label>Icon (1:1)</label>
                    <div>
                        <img v-if="advocacy.icon" style="height: 80px; border-radius: 6px;" :src="advocacy.icon">
                        <input :class="advocacy.icon ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadIcon">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group px-3">
                    <label>Image</label>
                    <div>
                        <img v-if="advocacy.image" style="height: 80px; border-radius: 6px;" :src="advocacy.image">
                        <input :class="advocacy.image ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadMemberImage">
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Advocacy Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Advocacy" size="xl" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" v-model="edit_advocacy.title" placeholder="Enter advocacy title" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Youtube Video Link</label>
                        <input class="form-control" type="text" v-model="edit_advocacy.link" placeholder="Enter youtube video link" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Category</label>
                        <select class="form-control digits" v-model="edit_advocacy.category">
                            <option v-for="(type, index) in categories" :key="index" :value="type.id">{{ type.title }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Description</label>
                        <ckeditor :editor="editor" v-model="edit_advocacy.description" placeholder="Enter advocacy description"></ckeditor>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group px-3">
                    <label>Icon (1:1)</label>
                    <div>
                        <img v-if="show_icon" style="height: 60px; border-radius: 6px;" :src="show_icon">
                        <input :class="show_icon ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadIcon2">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group px-3">
                    <label>Image</label>
                    <div>
                        <img v-if="show_image" style="height: 80px; border-radius: 6px;" :src="show_image">
                        <input :class="show_image ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadMemberImage2">
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Advocacy Lab Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this Advocacy?</div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    myHost
} from '../../../../_helpers/host';
import loader from '../../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
    components: {
        loader
    },

    data() {
        return {
            editor: ClassicEditor,
            host: myHost.host,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'category',
                    label: 'Category',
                    sortable: true
                },
                {
                    key: 'description',
                    label: 'Description',
                    sortable: true
                },
                {
                    key: 'image',
                    label: 'Image',
                    sortable: true
                },
                {
                    key: 'featured',
                    label: 'Featured',
                    sortable: true
                },
                {
                    key: 'custom',
                    label: 'Custom-UI',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],

            advocacy: {
                title: '',
                description: '',
                link: '',
                icon: null,
                image: null,
                category: ''
            },

            edit_advocacy: {
                id: '',
                title: '',
                description: '',
                link: '',
                icon: null,
                image: null,
                category: ''
            },

            delete_value: null,
            show_image: null,
            show_icon: null,
            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 15, 20]
        };
    },

    computed: {
        ...mapState({
            advocacy_list: state => state.advocacy.advocacy,
            categories: state => state.advocacy.category,
            loading: state => state.advocacy.advocacyLoading,
            error: state => state.advocacy.advocacyError
        }),

        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        }
    },

    mounted() {
        this.$store.dispatch("advocacy/fetchCategory")
        this.$store.dispatch("advocacy/fetchAdvocacy").then(() => {
            this.items = this.advocacy_list
            this.totalRows = this.advocacy_list.length;
        });
    },

    methods: {
        uploadMemberImage(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.advocacy.image = e.target.result
            };
        },

        uploadMemberImage2(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.edit_advocacy.image = e.target.result
                this.show_image = e.target.result
            };
        },

        uploadIcon(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.advocacy.icon = e.target.result
            };
        },

        uploadIcon2(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.edit_advocacy.icon = e.target.result
                this.show_icon = e.target.result
            };
        },

        toggleFeatured(type){
            this.$store.dispatch("advocacy/toggleFeatured", {
                id: type
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            }) 
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.advocacy = {
                title: '',
                description: '',
                link: '',
                icon: null,
                image: null,
                category: null
            };
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("advocacy/addAdvocacy", {
                advocacy: this.advocacy
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editAdvocacy(detail) {
            this.edit_advocacy = {
                id: detail.id || null,
                title: detail.title || '',
                link: detail.link || '',
                description: detail.description || null,
                category: detail.category?.id || null,
                featured: detail.featured || false
            };
            this.show_image = this.host + detail.image || null
            this.show_icon = this.host + detail.icon || null
        },

        resetEditModal() {
            this.edit_advocacy = {
                id: '',
                title: '',
                link: '',
                description: '',
                icon: null,
                image: null,
                category: null
            };
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {
            this.$store.dispatch("advocacy/updateAdvocacy", {
                id: this.edit_advocacy.id,
                advocacy: this.edit_advocacy
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetEditModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },

        deleteAdvocacy(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("advocacy/deleteAdvocacy", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
